export default {
state: {
		project:{},
		budgetId:"",
		checkId:"",
		planId:"",
		researchId:"",
		payId: "",
		tenderId: "",
		delId:"",
		invoiceId:"",
		receiptId:"",
		financialProjectFlag: "",
		financialDelFlag: "",
		financialTenderFlag: "",
	},
	mutations: {
		setFinancialTenderFlag(state, financialTenderFlag) { 
			state.financialTenderFlag = financialTenderFlag
		},
		setFinancialDelFlag(state, financialDelFlag) { 
			state.financialDelFlag = financialDelFlag
		},
		setFinancialProjectFlag(state, financialProjectFlag) { 
			state.financialProjectFlag = financialProjectFlag
		},
		setReceiptId(state, receiptId) { 
			state.receiptId = receiptId
		},
		setInvoiceId(state, invoiceId) { 
			state.invoiceId = invoiceId
		},
		setBudgetId(state, budgetId) { 
			state.budgetId = budgetId
		},
		setCheckId(state, checkId) { 
			state.checkId = checkId
		},
		setPlanId(state, planId) { 
			state.planId = planId
		},
		setResearchId(state, researchId) { 
			state.researchId = researchId
		},
		setProject(state, project) {
			state.project = project
		},
				setPayId(state, payId) {
			state.payId = payId
		},
		setTenderId(state, tenderId) {
			state.tenderId = tenderId
		},
		setDelegateId(state, delId) {
			state.delId = delId
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/financial.js